import { ICommonStore, commonStore } from "./CommonStore";
import { ICustomerStore, customerStore } from "./CustomerStore";
import { IOrdersStore, ordersStore } from "./OrdersStore";
import { IArticleStore, articleStore } from "./ArticleStore";
import { ILoginStore, loginStore } from "./LoginStore";

export interface IStore {
    commonStore: ICommonStore;
    customerStore: ICustomerStore;
    ordersStore: IOrdersStore;
    articleStore: IArticleStore;
    loginStore: ILoginStore;
};

export class Store implements IStore {
    commonStore: ICommonStore;
    customerStore: ICustomerStore;
    ordersStore: IOrdersStore;
    articleStore: IArticleStore;
    loginStore: ILoginStore;

    constructor() {
        this.commonStore = commonStore;
        this.customerStore = customerStore;
        this.ordersStore = ordersStore;
        this.articleStore = articleStore;
        this.loginStore = loginStore;
    }
}

export let store = new Store();

(window as any).store = store;